import { buildProps, definePropType } from '@ll-plus/utils'
import type { ExtractPropTypes } from 'vue'

import type Countdown from './countdown.vue'

export type TimeUnit = 'yyyy' | 'MM' | 'dd' | 'HH' | 'mm' | 'ss'

/** countdown: 按 value 时长倒计时；timer: 按 value 目标时间定时 */
export type CountdownMode = 'countdown' | 'timer'

export const countdownProps = buildProps({
  /** 显示的时间单位列表；未包含的单位会向下一级合并 */
  units: {
    type: definePropType<TimeUnit[]>(Array),
    default: (): TimeUnit[] => ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss'],
  },

  /**
   * 时间值：
   * - countdown 模式：时长（ms），如 60000 表示 60 秒
   * - timer 模式：目标时间（Date | 时间戳 ms | 日期字符串）
   */
  value: {
    type: definePropType<Date | number | string>([Date, Number, String]),
    default: 6000 * 60 * 60,
  },

  /** 倒计时模式：countdown = 按 value 时长倒计时；timer = 按 value 目标时间定时 */
  mode: {
    type: definePropType<CountdownMode>(String),
    default: 'countdown' as CountdownMode,
  },

  /** 是否开启倒计时 */
  active: {
    type: Boolean,
    default: false,
  },

  /** 秒的精度（小数位数），0 表示整秒 */
  precision: {
    type: Number,
    default: 0,
  },

  /** 倒计时主题 */
  theme: {
    type: definePropType<'dark' | 'light'>(String),
    default: 'dark',
  },

  /** 标题文本 */
  title: {
    type: String,
    default: '',
  },

  /** 标题样式 */
  titleStyle: {
    type: definePropType<Record<string, any>>(Object),
    default: () => ({}),
  },

  /** 倒计时完成时是否显示礼花特效 */
  showConfetti: {
    type: Boolean,
    default: true,
  },

  /** 是否显示控制按钮（开始/暂停、重置） */
  control: {
    type: Boolean,
    default: false,
  },
} as const)

export type CountdownProps = ExtractPropTypes<typeof countdownProps>

export const countdownEmits = {
  finish: () => true,
}

export type CountdownEmits = typeof countdownEmits

// instance
export type CountdownInstance = InstanceType<typeof Countdown>
